import React from "react";
import {OrderStatus} from "../../types/domain/orderStatus";
import {Order} from "../../types/domain/order";
import {ORDER_STATUS_COLORS} from "../../utils/orderUtils";

export interface Props {
    order: Order;
}

export const OrderStatusCircle: React.FC<Props> = ({order}) => {
    const {color, borderColor} = getStatusColor(order);

    const style = {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        marginRight: "8px",
        backgroundColor: color,
        border: `1px solid ${borderColor}`,
    };

    return <div style={style}></div>;
};

const getStatusColor = (order: Order): {color: string; borderColor: string} => {
    const status = (order.state?.toLowerCase() as OrderStatus) ?? OrderStatus.NEW;

    return ORDER_STATUS_COLORS[status];
};
